import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LEAD_CONTACTS_MANAGEMENT, LEAD_CONTACTS_MANAGEMENT_NO_BG } from 'src/app/common/models/tableColumns';
import { environment } from 'src/environments/environment';
import { AdministrationService } from '../administration.service';
import { DatePipe } from '@angular/common';

import { Router } from '@angular/router';
import * as _ from 'lodash';

interface UPD {
  tfcLevel1: string;
  updId: string;
  updName: string;
}

@Component({
  selector: 'app-lead-contacts-management',
  templateUrl: './lead-contacts-management.component.html',
  styleUrls: ['./lead-contacts-management.component.scss']
})
export class LeadContactsManagementComponent implements OnInit {

  star = 'fa fa-fw fa-search';
  loading = true;
  loadingregionalcomplainceListMessage;
  exportDialog = false;
  filteredRows: any = [];
  selectedRows: any = [];
  responsedataMarket;
  Id;
  fastRegionName;
  model: any = {};
  modelEdit: any = {};
  userId: any;
  userDetails: any;
  enterRegionName = false;
  isRegionEmpty = false;
  isMarketEmpty = false;
  isLDEmpty = false;
  status = [];
  prevName: any;
  prevStatus: any;
  uploadDialog = false;
  uploadedFiles: any[] = [];
  progress: number;
  message: string;
  selectedUPDname: any;
  dropDownupd: UPD[];
  selectedUpd: UPD;
  filetype = '.xlsx';
  ddlFormulationCategory: any;
  ddlFormulationType: any;
  ddlFormulationClass: any;
  ddlFormulationSubClass: any;
  rcl2AddForm: FormGroup;
  rcl2EditForm: FormGroup = this.fb.group({
    regionName: ['', Validators.required],
    productType: ['', Validators.required],
    updName: ['', Validators.required],
    isActive: ['']
  });
  updNameData: any = [];
  tfcmappingSelection: any;
  editId: any;
  submitted = false;
  changeEditClass = false;
  isCategoryHasData = 1;
  featureFragranceFlag: any;
  isSubClassCrossButtonClicked = false;
  buttonSelection = false;
  divisionData: any;
  filteredDataDivision = [];
  division: any;
  selectedFC = '';
  divisionId: any;
  filteredDataFC = [];
  selectedType = '';
  filteredDataType = [];
  filteredDataClass = [];
  selectedClass = '';
  filteredDataSubClass = [];
  selectedSubClass = '';
  selectedDivision = '';
  isUpdChangedInEditForm = false;
  leadContactsListColumns;
  leadContactsListData: any;
  addregionalComplains = false;
  editregionalComplains = false;
  addregionalComplainsSearch = false;
  listTypeToDD = [];
  selectedTypes = [];
 isSuperAdmin: any;
  openPopUp = false;
  contactName = '';
  contactEmail = '';
  isEmailValid = false;
  selectedListType: any;
  selectedStatus: any;
  selectedBusinessGroup: any;
  selectedCategories: any[] = [];
  categoryList: any[] = [];
  selectedMarkets: any[] = [];
  allMarketsList: any[] = [];
  selectedSingleCategory: any;
  selectedSingleMarket: any;
  editCategoryId: any;
  editCategoryName: any;
  editMarketId: any;
  editMarketName: any;
  isAddMode = true;
  updNameDataApi: any;
  disableFC = true;
  disableSubmit = true;
  listTypeOptions = null;
  popupHeaderValue: string;
  editRowId: any;
  selectedMasterListType: any;
  disableBGSelection = false;
  disableStatusSelection = false;

  constructor(
    private apiService: AdministrationService,
    public matSnackBar: MatSnackBar,
    private http: HttpClient,
    public fb: FormBuilder,
    public router: Router,
    private datePipe: DatePipe,
  ) { }

  ngOnInit() {
    this.getListTypes();
    this.resetAddPopUpValues();
    this.updDropDown();
    this.selectedStatus = '1';
    // By default, exclude market and category columns. They will be shown only for Self-Assessment Notification
    this.leadContactsListColumns = LEAD_CONTACTS_MANAGEMENT.filter(col => col.field !== 'market' && col.field !== 'category');
    this.userDetails = JSON.parse(localStorage.getItem('userRolesPermissions'));
    this.userDetails.roles.forEach(c => {
          if (c.roleId === 150) {
            this.isSuperAdmin = true;
          }
        });

    if (this.userDetails != null) {
      if (this.isSuperAdmin === 'false' || this.userDetails.roles.filter(r => r.roleId === 150).length <= 0) {
        this.loading = false;
        this.router.navigate(['/home']);
      }
    }
    if (this.userDetails != null) {
      this.userId = this.userDetails.userId;
    }
    this.addParentProperties();
  }
  updDropDown() {
    const apiurl = environment.APIFAsT + '/getsubstancesearchupds';
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.dropDownupd = response1;
    });
  }

  getMarketData() {
    this.loading = true;
    const apiurl = environment.APIFAsT + '/allmarkets';
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.loading = false;
      this.allMarketsList = response1;
    }, (error) => {
      this.loading = false;
    });
  }

  onBusinessGroupSelectionChange(): void {
    this.selectedCategories = [];
    this.selectedSingleCategory = null;
    this.categoryList = [];
    this.disableFC = true;

    if (this.selectedBusinessGroup && this.selectedBusinessGroup !== 'null' && this.dropDownupd) {
      const selectedBg = this.dropDownupd.find((item: UPD) => item.updId === this.selectedBusinessGroup);
      if (selectedBg) {
        this.updNameDataApi = selectedBg.updName;
        this.getGroupDataFormulationCategory(selectedBg);
      }
    }

    this.enableOrDisableSubmit();
  }

  getGroupDataFormulationCategory(typeValue: any): void {
    this.loading = true;
    this.loadingregionalcomplainceListMessage = 'Getting Categories';
    const apiurl = environment.APIFAsT + '/upd/' + this.updNameDataApi + '/tfc/level/1/' + typeValue.updId;
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.loading = false;
      this.categoryList = response1;
      this.disableFC = false;
      // If in edit mode, find and set the matching category from the loaded list
      if (!this.isAddMode && (this.editCategoryId || this.editCategoryName)) {
        let matchedCategory = null;
        // Try to match by ID first
        if (this.editCategoryId) {
          matchedCategory = this.categoryList.find((cat: any) =>
            cat.tfcLevel1Id === this.editCategoryId ||
            cat.tfcLevel1Id === this.editCategoryId
          );
        }
        // If not found by ID, try to match by name
        if (!matchedCategory && this.editCategoryName) {
          matchedCategory = this.categoryList.find((cat: any) =>
            cat.tfcLevel1Name === this.editCategoryName ||
            cat.tfcLevel1Name.toLowerCase() === this.editCategoryName.toLowerCase()
          );
        }
        // Set the selected category
        if (matchedCategory) {
          this.selectedSingleCategory = matchedCategory.tfcLevel1Id;
        }
      }
    }, (error) => {
      this.loading = false;
      this.categoryList = [];
      this.disableFC = true;
    });
  }
  getRegionalComplainceList(selectedTypes) {
    this.leadContactsListColumns = this.getLeadContactsColumns(selectedTypes);
    this.loadingregionalcomplainceListMessage = 'Getting Contacts Details';
    this.loading = true;
    const apiurl = environment.APIFAsT + '/getLeadContactsManagement';
    const apiBody = {
      id: null,
      groupTypeId: selectedTypes.groupId,
      name: null,
      email: null,
      active: null,
      divisionId: null,
      submittedBy: null,
      submittedDate: null,
      updatedBy: null,
      updatedDate: null
    };
    this.apiService.postComponentMasterData(apiurl, apiBody).subscribe((response1) => {
      this.loading = false;
      if (response1.length !== 0) {
        this.leadContactsListData = response1.map(respElem => {
          return {
            id: respElem.id,
            groupTypeId: respElem.groupTypeId,
            name: respElem.name,
            email: respElem.email,
            active: respElem.active,
            divisionId: respElem.divisionId,
            category: respElem.category || respElem.categoryName || '',
            categoryId: respElem.categoryId || '',
            market: respElem.marketName || (respElem.market && (respElem.market.marketName || respElem.market.name)) || respElem.market || '',
            marketId: respElem.marketId || '',
            submittedBy: respElem.submittedBy,
            submittedDate: respElem.submittedDate ? this.datePipe.transform(new Date(respElem.submittedDate), 'dd-MM-yyyy') : '',
            updatedBy: respElem.updatedBy,
            updatedDate: respElem.updatedDate ? this.datePipe.transform(new Date(respElem.updatedDate), 'dd-MM-yyyy') : '',
          };
        });
      } else {
        this.leadContactsListData = [];
      }
    }, (error) => {
      this.loading = false;
    });
  }

  addParentProperties() {
    this.loading = true;
    // this.loadingMsg = 'Fetching CUC Properties';
    const apiurl = environment.APIFAsT + '/leadgroupmaster';
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.loading = false;
      this.listTypeToDD = response1;
    }, (error) => {
      this.loading = false;
    });
  }


  onListTypeChange() {
    // Load market data only for Self-Assessment Notification type
    if (this.isSelfAssessmentNotificationSelection(this.selectedListType)) {
      this.getMarketData();
    }
  }

  addLeadContacts() {
    this.openPopUp = true;
    this.popupHeaderValue = 'Add Contact';
    this.isAddMode = true;
    this.disableStatusSelection = true;
    this.selectedCategories = [];
    this.selectedMarkets = [];
    this.selectedSingleCategory = null;
    this.selectedSingleMarket = null;
    this.categoryList = [];
    this.disableFC = true;
  }

  private getLeadContactsColumns(selectedType: any) {
    const baseColumns = this.isSIRSelection(selectedType) ? LEAD_CONTACTS_MANAGEMENT_NO_BG : LEAD_CONTACTS_MANAGEMENT;
    if (this.isSelfAssessmentNotificationSelection(selectedType)) {
      // For Self-Assessment: remove 'name' field, keep market and category
      return baseColumns.filter(col => col.field !== 'name');
    } else {
      // For other types: remove 'market' and 'category' fields
      return baseColumns.filter(col => col.field !== 'market' && col.field !== 'category');
    }
  }

  private isSIRSelection(selectedType: any): boolean {
    const selectedTypeValue = selectedType && typeof selectedType === 'object' ? selectedType.groupId : selectedType;
    return selectedTypeValue === '2';
  }

  private isSelfAssessmentNotificationSelection(selectedType: any): boolean {
    const selectedTypeValue = selectedType && typeof selectedType === 'object' ? selectedType.groupId || selectedType.groupName || selectedType.id : selectedType;
    let selectedGroup = null;

    if (this.listTypeOptions && this.listTypeOptions.length) {
      selectedGroup = this.listTypeOptions.find((grp: any) => grp.groupId === selectedTypeValue || grp.id === selectedTypeValue);
    }

    if (!selectedGroup && this.listTypeToDD && this.listTypeToDD.length) {
      selectedGroup = this.listTypeToDD.find((grp: any) => grp.groupId === selectedTypeValue || grp.id === selectedTypeValue);
    }

    const selectedGroupName = selectedGroup && selectedGroup.groupName
      ? selectedGroup.groupName
      : (selectedType && typeof selectedType === 'object' ? selectedType.groupName || '' : '');
    return (selectedGroupName || '').trim().toLowerCase() === 'self-assessment notification';
  }

  resetAddPopUpValues() {
    this.openPopUp = false;
    this.isAddMode = true;
    this.contactName = '';
    this.contactEmail = '';
    this.selectedListType = null;
    this.selectedStatus = '1';
    this.selectedBusinessGroup = null;
    this.selectedCategories = [];
    this.selectedMarkets = [];
    this.selectedSingleCategory = null;
    this.selectedSingleMarket = null;
    this.editCategoryId = null;
    this.editCategoryName = null;
    this.editMarketId = null;
    this.editMarketName = null;
    this.categoryList = [];
    this.disableFC = true;
    this.disableBGSelection = false;
    this.disableStatusSelection = false;
    this.enableOrDisableSubmit();
  }

  old_resetAddPopUpValues() {
    this.openPopUp = false;
    this.isAddMode = true;
    this.contactName = '';
    this.contactEmail = '';
    this.selectedListType = null;
    this.selectedStatus = '1';
    this.selectedBusinessGroup = null;
    this.selectedCategories = [];
    this.selectedMarkets = [];
    this.selectedSingleCategory = null;
    this.selectedSingleMarket = null;
    this.editCategoryId = null;
    this.editCategoryName = null;
    this.editMarketId = null;
    this.editMarketName = null;
    this.categoryList = [];
    this.disableFC = true;
    this.disableBGSelection = false;
    this.disableStatusSelection = false;
    this.enableOrDisableSubmit();
  }
  submitPopUpValues() {
    if (this.popupHeaderValue === 'Add Contact') {
      this.addPopupValues();
    } else {
      this.editPopupValues();
    }
  }

  checkForDuplicateAndThenAddOrEditRecord(EditOrAddApiUrl, EditOrAddApiBody) {
    this.selectedMasterListType = this.getMasterSelection();
    // if Duplicate record then show error Else Call API
    const isDuplicateExists = this.checkForDuplicate(EditOrAddApiBody.categoryId, EditOrAddApiBody.marketId);
    if (isDuplicateExists) {
      this.loading = false;
      this.openPopUp = false;
      this.disableBGSelection = false;
      this.matSnackBar.open('The Email ID you are trying to add already exists', 'close', {
        duration: 5000,
        panelClass: ['error']
      });
    } else {
      this.loading = true;
      this.callAddOrEditAPI(EditOrAddApiUrl, EditOrAddApiBody);
    }
  }

  checkForDuplicate(categoryId?: any, marketId?: any) {
    if (this.popupHeaderValue === 'Add Contact') {
      for (let i = 0; i < this.leadContactsListData.length; i++) {
        const element = this.leadContactsListData[i];
        if (this.contactEmail === element.email) {
          if (this.disableBGSelection) {
            // If notify SIR then directly return true else check for BG
            return true;
          } else {
            const bgId = this.getBussinessGrpId(element.divisionId);
            if (this.selectedBusinessGroup === bgId) {
              // For Self-Assessment Notification, also check market and category
              if (this.isSelfAssessmentNotificationSelection(this.selectedListType)) {
                if (categoryId && marketId) {
                  if (Number(element.marketId) === Number(marketId) && Number(element.categoryId) === Number(categoryId)) {
                    return true;
                  }
                }
              } else {
                return true;
              }
            }
          }
        }
      }
    } else {
      for (let i = 0; i < this.leadContactsListData.length; i++) {
        const element = this.leadContactsListData[i];
        if (element.id !== this.editRowId) {
          if (this.contactEmail === element.email) {
            if (this.disableBGSelection) {
              // If notify SIR then directly return true else check for BG
              return true;
            } else {
              const bgId = this.getBussinessGrpId(element.divisionId);
              if (this.selectedBusinessGroup === bgId) {
                // For Self-Assessment Notification, also check market and category
                if (this.isSelfAssessmentNotificationSelection(this.selectedListType)) {
                  if (this.selectedSingleMarket && this.selectedSingleCategory) {
                    if ((element.marketId === this.selectedSingleMarket || element.marketId === this.selectedSingleMarket) &&
                        (element.categoryId === this.selectedSingleCategory || element.categoryId === this.selectedSingleCategory)) {
                      return true;
                    }
                  }
                } else {
                  return true;
                }
              }
            }
          }
        }
      }
    }
    return false;
  }
  callAddOrEditAPI(apiurl, apiBody) {
    this.apiService.postData(apiurl, apiBody).subscribe((response) => {
      this.loading = false;
      this.selectedMasterListType = this.getMasterSelection();
      this.getRegionalComplainceList({ groupId: this.selectedListType });
      this.openPopUp = false;
      this.disableBGSelection = false;
      const msg = this.popupHeaderValue === 'Add Contact' ? 'Successfully Added.' : 'Successfully Updated.';
      this.matSnackBar.open(msg, 'close', {
        duration: 3000,
        panelClass: ['success']
      });
    }, (error) => {
      this.loading = false;
      this.matSnackBar.open(error.error.message, 'close', {
        duration: 3000,
        panelClass: ['error']
      });
    });
  }
  getLeadContactsData() {
    // Get List of contacts based on list type being added/Edited
    const selectedTypes = { groupId: this.selectedListType };
    this.leadContactsListColumns = this.getLeadContactsColumns(selectedTypes);
    const getapiurl = environment.APIFAsT + '/getLeadContactsManagement';
    const apiBody = {
      id: null, groupTypeId: selectedTypes.groupId, name: null, email: null, active: null,
      divisionId: null, submittedBy: null, submittedDate: null, updatedBy: null, updatedDate: null
    };
    this.apiService.postComponentMasterData(getapiurl, apiBody).subscribe((response1) => {
      this.loading = false;
      if (response1.length !== 0) {
        this.leadContactsListData = response1.map(respElem => {
          return {
            id: respElem.id, groupTypeId: respElem.groupTypeId, name: respElem.name, email: respElem.email,
            active: respElem.active, divisionId: respElem.divisionId,
            category: respElem.category || respElem.categoryName || '',
            categoryId: respElem.categoryId || '',
            market: respElem.marketName || (respElem.market && (respElem.market.marketName || respElem.market.name)) || respElem.market || '',
            marketId: respElem.marketId || '',
            submittedBy: respElem.submittedBy,
            submittedDate: respElem.submittedDate ? this.datePipe.transform(new Date(respElem.submittedDate), 'dd-MM-yyyy') : '',
            updatedBy: respElem.updatedBy,
            updatedDate: respElem.updatedDate ? this.datePipe.transform(new Date(respElem.updatedDate), 'dd-MM-yyyy') : '',
          };
        });
      } else {
        this.leadContactsListData = [];
      }
    }, (error) => {
      this.loading = false;
    });
  }
  addPopupValues() {
    this.loading = true;
    const userDetails = JSON.parse(localStorage.getItem('userRolesPermissions'));
    this.loadingregionalcomplainceListMessage = 'Adding Contact';
    const contactNameValue = this.contactName ? this.contactName.trim() : '';
    const apiurl = environment.APIFAsT + '/addLeadContactsManagement';
    this.getLeadContactsData();
    // For Self-Assessment Notification: loop through categories and markets
    if (this.isSelfAssessmentNotificationSelection(this.selectedListType)) {
      if (this.selectedCategories.length === 0 || this.selectedMarkets.length === 0) {
        this.loading = false;
        this.matSnackBar.open('Please select at least one category and one market', 'close', {
          duration: 5000,
          panelClass: ['error']
        });
        return;
      }
      // Loop through all combinations of categories and markets
      this.selectedCategories.forEach(category => {
        this.selectedMarkets.forEach(market => {
          const apiBody = {
            groupTypeId: this.selectedListType,
            name: contactNameValue,
            email: this.contactEmail.trim(),
            active: this.selectedStatus,
            divisionId: this.selectedBusinessGroup === 'null' ? '0' : this.selectedBusinessGroup,
            categoryId: category.tfcLevel1Id || category,
            marketId: market.marketId || market,
            submittedBy: userDetails.userId,
            submittedDate: new Date(),
            updatedBy: null,
            updatedDate: null
          };
          this.checkForDuplicateAndThenAddOrEditRecord(apiurl, apiBody);
        });
      });
    } else {
      // For other list types: add single record
      const apiBody = {
        groupTypeId: this.selectedListType,
        name: contactNameValue,
        email: this.contactEmail.trim(),
        active: this.selectedStatus,
        divisionId: this.selectedBusinessGroup === 'null' ? '0' : this.selectedBusinessGroup,
        submittedBy: userDetails.userId,
        submittedDate: new Date(),
        updatedBy: null,
        updatedDate: null
      };
      this.checkForDuplicateAndThenAddOrEditRecord(apiurl, apiBody);
    }
  }
  editPopupValues() {
    this.loading = true;
    const userDetails = JSON.parse(localStorage.getItem('userRolesPermissions'));
    this.loadingregionalcomplainceListMessage = 'Editing Contact';
    const contactNameValue = this.contactName ? this.contactName.trim() : '';
    const apiurl = environment.APIFAsT + '/updateleadcontacts';

    this.getLeadContactsData();
    // For Self-Assessment Notification: include categoryId and marketId only
    if (this.isSelfAssessmentNotificationSelection(this.selectedListType)) {
      const apiBody = {
        id: this.editRowId,
        groupTypeId: this.selectedListType,
        name: contactNameValue,
        email: this.contactEmail.trim(),
        active: this.selectedStatus,
        divisionId: this.selectedBusinessGroup === 'null' ? '0' : this.selectedBusinessGroup,
        categoryId: this.selectedSingleCategory || '',
        marketId: this.selectedSingleMarket || '',
        submittedBy: null,
        submittedDate: null,
        updatedBy: userDetails.userId,
        updatedDate: null
      };
      this.checkForDuplicateAndThenAddOrEditRecord(apiurl, apiBody);
    } else {
      // For other list types: edit without category/market
      const apiBody = {
        id: this.editRowId,
        groupTypeId: this.selectedListType,
        name: contactNameValue,
        email: this.contactEmail.trim(),
        active: this.selectedStatus,
        divisionId: this.selectedBusinessGroup === 'null' ? '0' : this.selectedBusinessGroup,
        submittedBy: null,
        submittedDate: null,
        updatedBy: userDetails.userId,
        updatedDate: null
      };
      this.checkForDuplicateAndThenAddOrEditRecord(apiurl, apiBody);
    }
  }
  enableOrDisableSubmit() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const contactNameValue = this.contactName ? this.contactName.trim() : '';
    const hasName = this.isSelfAssessmentNotificationSelection(this.selectedListType) || contactNameValue.length > 0;
    this.isEmailValid = this.contactEmail ? emailRegex.test(this.contactEmail.trim()) : false;
    // Check category and market selection for Self-Assessment Notification
    const hasCategoryAndMarket = this.isSelfAssessmentNotificationSelection(this.selectedListType)
      ? (this.isAddMode ? (this.selectedCategories.length > 0 && this.selectedMarkets.length > 0) : (this.selectedSingleCategory && this.selectedSingleMarket))
      : true;
    if (this.selectedListType !== '2') {
      if (hasName && this.contactEmail.trim() && this.isEmailValid && this.selectedListType && this.selectedStatus && this.selectedBusinessGroup && this.selectedListType !== 'null' && this.selectedBusinessGroup !== 'null' && hasCategoryAndMarket) {
        this.disableSubmit = false;
      } else {
        this.disableSubmit = true;
      }
    } else {
      if (this.contactEmail.trim() && this.isEmailValid && this.selectedListType && this.selectedStatus && this.selectedListType !== 'null') {
        this.disableSubmit = false;
      } else {
        this.disableSubmit = true;
      }
    }
  }
  getListTypes() {
    const apiurl = environment.APIFAsT + '/leadgroupmaster';
    this.apiService.getData(apiurl).subscribe((response) => {
      this.loading = false;
      this.listTypeOptions = response;
    }, (error) => {
      this.loading = false;
      this.matSnackBar.open(error.error.message, 'close', {
        duration: 3000,
        panelClass: ['error']
      });
    });
  }
  onFilter(event) {
    if (event.filters != null) {
      this.filteredRows = (Object.keys(event.filters).length === 0 ? [] : event.filteredValue);
    }
  }

  selectRow(row) {
    if (row._selection === null || row._selection === undefined) {
      this.buttonSelection = false;
    } else {
      this.buttonSelection = true;
    }
  }

  editLeadContacts(tableData) {
    this.popupHeaderValue = 'Edit Contact';
    this.isAddMode = false;
    const rowData = tableData._selection;
    this.editRowId = rowData.id;
    this.contactName = rowData.name;
    this.contactEmail = rowData.email;
    this.selectedListType = this.getListTypeId(rowData.groupTypeId);
    this.selectedStatus = rowData.active === 'Active' ? '1' : '0';
    this.selectedBusinessGroup = this.getBussinessGrpId(rowData.divisionId);
    this.disableBG();
    this.disableStatusSelection = false;
    // Store the category and market data for edit mode
    if (this.isSelfAssessmentNotificationSelection(this.selectedListType)) {
      this.editCategoryId = rowData.categoryId || '';
      this.editCategoryName = rowData.category || '';
      this.editMarketId = rowData.marketId || '';
      this.editMarketName = rowData.market || '';
      // Fetch categories for the selected business group
      if (this.selectedBusinessGroup && this.selectedBusinessGroup !== 'null' && this.dropDownupd) {
        const selectedBg = this.dropDownupd.find((item: UPD) => item.updId === this.selectedBusinessGroup);
        if (selectedBg) {
          this.updNameDataApi = selectedBg.updName;
          this.getGroupDataFormulationCategory(selectedBg);
        }
      }
      // Set market value
      if (this.editMarketId && this.allMarketsList.length > 0) {
        const matchedMarket = this.allMarketsList.find((market: any) =>
          market.marketId === this.editMarketId ||
          market.marketId === this.editMarketId
        );
        if (matchedMarket) {
          this.selectedSingleMarket = matchedMarket.marketId;
        } else if (this.editMarketId) {
          this.selectedSingleMarket = this.editMarketId;
        }
      }
    }
    this.openPopUp = true;
    this.enableOrDisableSubmit();
  }
  getListTypeId(listType) {
    for (let i = 0; i < this.listTypeOptions.length; i++) {
      const element = this.listTypeOptions[i];
      if (listType === element.groupName) {
        return element.groupId;
      }
    }
    return undefined;
  }

  getBussinessGrpId(bg: string): string | undefined {
  for (let i = 0; i < this.dropDownupd.length; i++) {
    const element = this.dropDownupd[i];
    if (bg === element.updName) {
      return element.updId;
    }
  }
  return undefined;
}

  getMasterSelection() {
    const selectedGrp = {
      id: '',
      groupId: '',
      groupName: ''
    };
    this.listTypeToDD.forEach(grp => {
      if (grp.groupId === this.selectedListType) {
        selectedGrp.id = grp.id;
        selectedGrp.groupId = grp.groupId;
        selectedGrp.groupName = grp.groupName;
        return selectedGrp;
      }
    });
    return selectedGrp;
  }
  disableBG() {
    if (this.selectedListType === '2') {
      this.selectedBusinessGroup = 'null';
      this.disableBGSelection = true;
    } else {
      this.disableBGSelection = false;
    }
  }
}
